import React, { useEffect } from "react";
import { Table } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { getProfileDashboardAsync } from "../../../Auth/_redux";

export const MyBalanceTab = ({ profileDashboard }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getProfileDashboardAsync());
  }, []);

  return (
    <div className="tblmrgn mt-0 lwpddng cstm_pddng">
      <div className="row justify-content-center row_wt_pdng">
        <div className="col-md-11">
          <div className="row">
            <div className="col-xl-4">
              <div className="pr_wt_box">
                <h6>Gold Available</h6>
                <h3 className="text-break">
                  {profileDashboard.goldAcquired} <span>GRAMS</span>
                </h3>
              </div>
            </div>
            {/* <div className="col-xl-4">
              <div className="pr_wt_box">
                <h6>Withdrawal Tokens</h6>
                <h3>{profileDashboard.withdarawTokens}</h3>
              </div>
            </div> */}
            <div className="col-xl-4">
              <div className="pr_wt_box">
                <h6>available tokens</h6>
                <h3>{profileDashboard.availableTokens} </h3>
              </div>
            </div>
            <div className="col-md-12 d-flex align-items-center mt-10">
              <h4 className="fn_s_18 f-w-500 color_blk">Gold Acquired List</h4>
              {/* <button type="button" className="btn btn-def btn-defv6 ml-auto">Buy More</button> */}
            </div>
            <div className="col-md-12 mt-3">
              <div className="mt-0">
                <Table
                  hover
                  responsive
                  className="mb-0 default_table mrpdng_tbl"
                >
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Gold Bar ID</th>
                      <th>Gold Acquired (GRAMS)</th>
                      <th>Tokens</th>
                    </tr>
                  </thead>
                  <tbody>
                    {profileDashboard.list.length ? (
                      profileDashboard.list.map((list) => (
                        <tr key={list._id}>
                          <td>{new Date(list.timeStamp).toLocaleString()}</td>
                          <td>{list.goldBarId}</td>
                          <td>{list.units}</td>
                          <td>{list.tokens}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={5} className="text-center">
                          No Record Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
